import { AppNotificationObject, SharedLink } from 'src/app/shared';
import { Entity, UserSchema } from '../models';

export interface UserScore extends Entity {
  sharedLink: SharedLink;
  user: UserSchema;
  amount: number;
  notificationObjects?: AppNotificationObject[];
}

export enum UserRoles {
  ADMIN = 1522,
  MANAGER = 3549,
  USER = 3635,
}
